<template>
  <div class="container disp-ali-cen-fldir-col borbox30_2" v-wechat-title="$route.meta.title">
    <div class="topTitle"><img @click="backLast" class="backImg" src="../assets/pingzi/back.png" alt="">{{$route.meta.title}}</div>
    <div style="width: 100%;height: 0.8rem;background: transparent;"></div>
    <div class="baseSetBox disp-just-flsta-ali-cen-fldir-col">
      <div class="actTile disp-just-bet-ali-cen">
        <div style="" class="title disp-just-bet-ali-cen">
          <img class="" src="../assets/icon/shr.png" />
          <i class="">收货人</i>
        </div>
        <input class="inputTitle" placeholder="请输入收货人名称" v-model="userName">
        <div style="opacity:0;" class="other1">元</div>
      </div>
      <div class="actTile disp-just-bet-ali-cen">
        <div class="title disp-just-bet-ali-cen">
          <img class="" src="../assets/icon/sjhm.png" />
          <i class="">手机号码</i>
        </div>
        <input class="inputTitle" placeholder="请输入手机号码" v-model="mobile" type='number'>
        <div style="opacity:0;" class="other1">元</div>
      </div>
      <div class="actTile disp-just-bet-ali-cen">
        <div class="title disp-just-bet-ali-cen">
          <img class="" src="../assets/icon/szdq.png" />
          <i class="">所在地区</i>
        </div>
        <div></div>
        <div class="" style="font-size:0.24rem;color:#999;width:60%;display:block;" @click="showPopup" v-show="tempArr.length < 3">
          请选择地区
        </div>
        <div class="" style="font-size:0.26rem;width:60%;display:block;" @click="showPopup" v-if="tempArr.length >= 3">
          {{tempArr[0].name+' '+tempArr[1].name+' '+tempArr[2].name}}
        </div>
        <div style="opacity:0;" class="other1">元</div>
      </div>
      <div class="actTile disp-just-bet-ali-cen">
        <div class="title disp-just-bet-ali-cen">
          <img class="" src="../assets/icon/shr1.png" />
          <i class="">详细地址</i>
        </div>
        <input class="inputTitle" placeholder="请输入详细地址" v-model="addDetail">
        <div style="opacity:0;" class="other1">元</div>
      </div>
    </div>
    <div class="setDefault flexSpBte">
      <i class="defaultTxt">设为默认地址</i>
      <!-- <i class="defaultTxt">设为默认地址</i>  -->
      <van-switch active-color="#4FAE54" inactive-color="#E0E0E0" @input='onInput' :value="checked" />
    </div>
    <div class="sureAddress" @click="saveAddress"><i>保存</i></div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '56%' }">
      <div class="areaBox">
        <div class="areaTit">配送至</div>
        <div class="selectTxt" v-show='tempArr.length > 0'>
          <span class="titleTxt" v-for="(item,index) in tempArr" :key="index" @click="delArea(item.id,index)">{{item.name}}</span>
        </div>
        <div :class="{areaLists:true, areaListsLow:tempArr.length > 0}" v-show="tempArr.length < 3">
        <p class="areaItem" v-for="(item,index) in addressArr" :key="index" @click="getAreasE(item.AreaID,item.Name)">{{item.Name}}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import '../styles/blues.css'
import '../styles/base1.css'
import util from '../utils/util'
import $ from '../utils/axios'
import axiosp from '../utils/axiosp'

export default {
  name: 'index',
  components: {

  },
  data() {
    return {
      checked: true,
      tapFlag: true,
      show: false,
      userName: '',
      mobile: '',
      addDetail: '',
      addressArr: [],
      tempArr: [],
      region: [],
      Id: '',//地址对应的id
      proId: '1',//北京市辖区 东城区
      cityId: '2',
      areaId: '4',
    };
  },
  created: function () {
    if (!!this.$route.query.id) {
      this.Id = this.$route.query.id
      this.$route.meta.title = '修改地址';
      this.getAdd(this.Id)
    } else {
      this.$route.meta.title = '添加地址';
    }

    this.$emit('footer', false);
  },
  mounted(e) {
    this.getAreas(0);
  },
  methods: {
	backLast(){
		this.$router.go(-1);//返回上一层
	},
    onInput(checked) {
      this.checked = checked;
    },
    showPopup() {
      this.show = !this.show;
    },
    // 获取省份
    getAreas(parentid) {
      this.$parent.Loading(true)
      axiosp.reqPost("User/GetAreas", {
        ParentId: parentid
      }).then(res => {
        this.$parent.Loading(false)
        this.addressArr = res.Data
      })
    },
    getAreasE(id, name) {
      if (this.tapFlag) {
        this.tempArr.push({
          id: id,
          name: name,
        })
        if (this.tempArr.length == 3) {
          this.showPopup();
          this.region = this.tempArr;
          this.addressArr = [];
        }
        if (this.tempArr.length < 3) {
          this.$parent.Loading(true)
          axiosp.reqPost("User/GetAreas", {
            ParentId: id
          }).then(res => {
            this.$parent.Loading(false)
            setTimeout(() => {
              this.tapFlag = true;
            }, 400);
            this.addressArr = res.Data;
          })
        }
      }
    },
    // 保存地址
    saveAddress() {
      var that = this;
      var verifing;
      verifing = that.getVerifing();
      util.verified(verifing)
      if (util.verified(verifing)) {
        var params = {
          Id: parseInt( that.Id) || 0,
          Contacts: that.userName,
          ObjID:util.getStoObj('allinfo').ADS_UserId,
          Mobile: that.mobile,
          IsdefaultAddress: that.checked ? 1 : 0,
          ProvinceID: that.tempArr[0].id,
          CityID: that.tempArr[1].id,
          CityZoneID: that.tempArr[2].id,
          Address: that.addDetail,
          ObjType: 1,
        }
        that.$parent.Loading(true)
        axiosp.reqPost("User/SaveUserAddress", {Model:JSON.stringify(params)}).then(res => {
          if (Number(that.Id) > 0) {
            util.toast('修改成功')
          } else {
            util.toast('添加成功')
          }
          that.$router.go(-1)
          that.$parent.Loading(false)
        })
      }
    },
    getVerifing() {
      let that = this;
      var arr = [{
        name: 'isEmpty',
        content: that.userName,
        tip: '请填写收货人'
      }, {
        name: 'isEmpty',
        content: that.mobile,
        tip: '请填写手机号码'
      }, {
        name: 'mobile',
        content: that.mobile,
        tip: '请填写正确手机号码'
      }, {
        name: 'isLengthZero',
        content: that.region,
        tip: '请选择地区信息'
      }, {
        name: 'isEmpty',
        content: that.addDetail,
        tip: '请填写详细地址'
      }
      ];
      return arr;
    },
    // 获取已有地址
    getAdd(id) {
      this.$parent.Loading(true)
      axiosp.reqPost("User/GetUserAddress", {
        GetClass: 0
      }).then(res => {
        this.$parent.Loading(false)
        if (res.Data && res.Data.length > 0) {
          res.Data.forEach(item => {
            if (item.Id == id) {
              this.addDetail = item.Address;
              this.mobile = item.Mobile;
              this.userName = item.Contacts;
              this.region = item.CompleteAddress;
              this.checked = item.IsdefaultAddress === 1 ? true : false;
              this.proId = item.ProvinceID;//北京市辖区 东城区
              this.cityId = item.CityID;
              this.areaId = item.CityZoneID;
            }
          })
          this.getProArea()
        }
      })
    },
    // 编辑的时候   获取已经选择的省市区
    getProArea() {
      // 保存地区id
      let _tempArr = [this.proId, this.cityId, this.areaId];
      let _tempPostArr = [0, this.proId, this.cityId];
      // 保存地区name
      let _tempArr2 = [];
      this.$parent.Loading(true)
      axiosp.reqPost("User/GetAreas", {
        ParentId: _tempPostArr[0]
      }).then(res => {
        res.Data.forEach(item2 => {
          if (item2.AreaID == _tempArr[0]) {
            _tempArr2.push(item2.Name)
            axiosp.reqPost("User/GetAreas", {
              ParentId: _tempPostArr[1]
            }).then(res => {
              res.Data.forEach(item3 => {
                if (item3.AreaID == _tempArr[1]) {
                  _tempArr2.push(item3.Name)
                  axiosp.reqPost("User/GetAreas", {
                    ParentId: _tempPostArr[2]
                  }).then(res => {
                    this.$parent.Loading(false)
                    res.Data.forEach(item4 => {
                      if (item4.AreaID == _tempArr[2]) {
                        _tempArr2.push(item4.Name)
                        _tempArr2.forEach((item5, index) => {
                          this.tempArr.push({
                            id: _tempArr[index],
                            name: _tempArr2[index],
                          })
                        })
                      }
                    })
                  })
                }
              })
            })
          }
        })
      })
    },
    // 删除更换选中区域
    delArea(id, index) {
      this.tempArr = this.tempArr.slice(0, index)
      if (this.tempArr.length == 0) {
        this.getAreas(0)
        this.region = [];
      } else {
        this.getAreas(this.tempArr[this.tempArr.length - 1].id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.areaBox {
  width: 100%;
  height: 100%;
  font-size: 0.36rem;
  box-sizing: border-box;
  padding: 0.3rem 0.5rem;
  .areaTit {
    margin-bottom: 0.1rem;
  }
  .areaLists {
    height: 94%;
    overflow: scroll;
    .areaItem {
      font-size: 0.32rem;
      height: 0.8rem;
      line-height: 0.8rem;
      border-bottom: 1px solid #f5f5f5;
    }
  }
  .areaListsLow {
    height: 88%;
  }
}
.selectTxt {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.3rem;
  color: #4fae54;
  .titleTxt {
    margin-right: 0.2rem;
  }
}
.sureAddress {
  position: fixed;
  bottom: 0.4rem;
  width: 94%;
  height: 1.08rem;
  line-height: 1.08rem;
  font-size: 0.34rem;
  text-align: center;
  background: rgba(79, 174, 84, 1);
  box-shadow: 0rem 0.09rem 0.07rem 1px rgba(79, 174, 84, 0.19);
  border-radius: 0.1rem;
  i {
    color: white;
  }
}
.setDefault {
  width: 100%;
  background-color: #fff;
  border-radius: 0.22rem;
  margin-top: 0.3rem;
  font-size: 0.28rem;
  height: 1.08rem;
  line-height: 1.08rem;
  box-sizing: border-box;
  padding: 0 0.44rem;
}
.container {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245) !important;
  position: relative;
}
.baseSetBox {
  width: 100%;
  background-color: #fff;
  border-radius: 0.22rem;
  // margin-top: 0.8rem;
  .actTile {
    width: 95%;
    height: 1.4rem;
    min-height: 1.4rem;
    border-bottom: 0.02rem solid #f5f5f5;
    .title {
      width: 2.2rem;
      font-size: 0.3rem;
      color: black;
      margin-right: 0.2rem;
      div {
        width: 0.08rem;
        height: 0.3rem;
        background-color: transparent;
      }
      img {
        width: 0.68rem;
        height: 0.68rem;
      }
      i {
        color: #383838;
        margin: 0 0.05rem;
        width: 1.2rem;
        text-align: left;
      }
    }
    .yPriceShow {
      width: 60%;
      // border: 1rem solid red;
      div:first-child {
        color: black;
        font-size: 0.32rem;
      }
      div:nth-child(2) {
        color: cadetblue;
        border: 1px solid cadetblue;
        border-radius: 0.1rem;
        font-size: 0.28rem;
        padding: 0.1rem;
      }
    }
    .jianySize {
      font-size: 0.24rem;
      color: black;
    }
    .inputTitle {
      width: 60%;
      border: 0 none;
      font-size: 0.3rem;
      color: black;
    }
    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 1);
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 1);
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 1);
    }
    :-moz-placeholder {
      /* Firefox 18- */
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 1);
    }
    .limitCheck {
      font-size: 0.24rem;
      color: rgb(136, 136, 136);
    }
    .other {
      width: 0.8rem;
      font-size: 0.26rem;
      color: rgb(188, 188, 188);
      text-align: right;
      img {
        width: 0.15rem;
        height: 0.26rem;
      }
    }
    .other1 {
      width: 0.8rem;
      font-size: 0.28rem;
      color: black;
      text-align: right;
    }
  }
  .addImg {
    width: 95%;
    // border: 1rem solid red;
    img {
      width: 3rem;
      height: 2rem;
    }
  }
}
.inputHolder {
  font-size: 0.28rem;
  color: rgb(188, 188, 188);
}
.tit-setting {
  text-align: left;
  width: 60%;
  // margin-top: -20rem;
  border-bottom: 0.02rem solid rgb(188, 188, 188);
  .tit-input {
    position: relative;
    margin-top: 0.42rem;
    margin-bottom: 0.3rem;
  }
}
.tit-seting {
  padding-bottom: 0.02rem;
}
.tit-inputa {
  margin: 0.25rem 0rem 0.1rem;
}
.picker-con {
  picker {
    height: 100%;
  }
  vertical-align: middle;
  display: inline-block;
  // width: 220rem;
  height: 0.58rem;
  border-radius: 0.08rem;
  color: black;
  font-size: 0.28rem;
  box-sizing: border-box;
  .picker {
    color: rgb(153, 153, 153);
    font-size: 0.3rem;
    padding-top: 0.1rem;
    min-height: 0.4rem;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    letter-spacing: 0.02rem;
  }
}
.checkaa {
  position: relative;
  top: -0.05rem;
}
.picker-con:last-child {
  margin-left: 0rem;
}
.pick-lefr {
  position: relative;
}
.saveBtn {
  width: 90%;
  height: 0.9rem;
  line-height: 0.9rem;
  background-color: #4fae54;
  color: white;
  font-size: 0.3rem;
  position: fixed;
  bottom: 0.5rem;
}
.hover-class {
  opacity: 0.6;
}
.areasBox {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 0.3rem;
  .areaList {
    border-radius: 0.3rem;
    width: 100%;
    height: 8rem;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 10;
    .titleTxt {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
    }
    .areaItem {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      border-bottom: 1px solid #f5f5f5;
      text-align: left;
    }
  }
}
.psTxt {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.36rem;
}
</style>
